import { restrictiveAnalysisTokens } from "../tokens";

interface ScoreGaugeProps {
  score: number;
  riskLabel: string;
  riskDescription: string;
}

const ARC_LENGTH = Math.PI * 80;

export function ScoreGauge({ score, riskLabel, riskDescription }: ScoreGaugeProps) {
  const { brandBlue, brandOrange } = restrictiveAnalysisTokens.colors;
  const clampedScore = Math.max(0, Math.min(score, 1000));
  const progress = clampedScore / 1000;
  const strokeValue = progress * ARC_LENGTH;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-base font-semibold" style={{ color: brandBlue }}>Score de Credito</h2>

      <div className="relative mx-auto w-full max-w-[320px]">
        <svg viewBox="0 0 200 120" className="h-40 w-full">
          <path
            d="M20 100 A80 80 0 0 1 180 100"
            fill="none"
            stroke="#E2E8F0"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M20 100 A80 80 0 0 1 180 100"
            fill="none"
            stroke={brandOrange}
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray={`${strokeValue} ${ARC_LENGTH}`}
          />
        </svg>

        <div className="absolute inset-0 flex flex-col items-center justify-center pt-10">
          <p className="text-4xl font-bold" style={{ color: brandBlue }}>{clampedScore}</p>
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500">de 1000</p>
        </div>
      </div>

      <p className="mt-3 text-sm font-semibold" style={{ color: brandBlue }}>{riskLabel}</p>
      <p className="mt-1 text-sm text-slate-600">{riskDescription}</p>
    </div>
  );
}
